(function () {
  /**
   * @ngdoc module
   * @name binky.core.common.model
   * @description Module which contains model related services
   */
  angular.module('binky.core.common.model', ['binky.core.lodash']);
})();
